import { ITreatmentPreference } from '../models/treatment-preference.interface';

export const ACCEPTANCE_COMMITMENT_THERAPY: ITreatmentPreference = {
  title: 'Acceptance \u0026 commitment therapy',
  tag: 'ACT'
};

export const ART_THERAPY: ITreatmentPreference = {
  title: 'Art therapy',
  tag: 'Art Therapy'
};

export const ATTACHMENT_BASED: ITreatmentPreference = {
  title: 'Attachment based',
  tag: 'Attachment Based'
};

export const BEHAVIORAL_MODIFICATION: ITreatmentPreference = {
  title: 'Behavioral modification',
  tag: 'Behavioral Modification'
};

export const INTEGRATIVE: ITreatmentPreference = {
  title: 'Integrative',
  tag: 'Integrative'
};

export const INTERNAL_FAMILY_SYSTEMS: ITreatmentPreference = {
  title: 'Internal Family Systems',
  tag: 'IFS'
};

export const INTERPERSONAL_PSYCHOTHERAPY: ITreatmentPreference = {
  title: 'Interpersonal Psychotherapy',
  tag: 'IPT'
};

export const JUNGIAN: ITreatmentPreference = {
  title: 'Jungian',
  tag: 'Jungian'
};

export const CHRISTIAN_COUNSELING: ITreatmentPreference = {
  title: 'Christian counseling',
  tag: 'Christian Counseling'
};

export const COGNITIVE_BEHAVIORAL_THERAPY: ITreatmentPreference = {
  title: 'Cognitive Behavioral Therapy (CBT)',
  tag: 'CBT'
};

export const EMOTIONALLY_FOCUSED: ITreatmentPreference = {
  title: 'Emotionally focused',
  tag: 'Emotionally Focused'
};

export const EMDR: ITreatmentPreference = {
  title: 'EMDR',
  tag: 'EMDR'
};

export const BIOFEEDBACK: ITreatmentPreference = {
  title: 'Biofeedback',
  tag: 'Biofeedback'
};

export const BRAINSPOTTING: ITreatmentPreference = {
  title: 'Brainspotting',
  tag: 'Brainspotting'
};

export const DIALECTICAL_BEHAVIORAL_THERAPY: ITreatmentPreference = {
  title: 'Dialectical Behavioral Therapy (DBT)',
  tag: 'DBT'
};

export const ECLECTIC: ITreatmentPreference = {
  title: 'Eclectic',
  tag: 'Eclectic'
};

export const EXISTENTIAL: ITreatmentPreference = {
  title: 'Existential',
  tag: 'Existential'
};

export const GESTALT: ITreatmentPreference = {
  title: 'Gestalt',
  tag: 'Gestalt'
};

export const GOTTMAN_METHOD: ITreatmentPreference = {
  title: 'Gottman Method',
  tag: 'Gottman Method'
};

export const HUMANISTIC: ITreatmentPreference = {
  title: 'Humanistic',
  tag: 'Humanistic'
};

export const MINDFULNESS: ITreatmentPreference = {
  title: 'Mindfulness',
  tag: 'Mindfulness'
};

export const NARRATIVE: ITreatmentPreference = {
  title: 'Narrative',
  tag: 'Narrative'
};

export const NEUROFEEDBACK: ITreatmentPreference = {
  title: 'Neurofeedback',
  tag: 'Neurofeedback'
};

export const PSYCHOANALYTIC: ITreatmentPreference = {
  title: 'Psychoanalytic',
  tag: 'Psychoanalytis'
};

export const PSYCHOBIOLOGICAL_APPROACH_COUPLES_THERAPY: ITreatmentPreference = {
  title: 'Psychobiological Approach to Couples Therapy (PACT)',
  tag: 'PACT'
};

export const PSYCHODYNAMIC: ITreatmentPreference = {
  title: 'Psychodynamic',
  tag: 'Psychodynamic'
};

export const PSYCHOLOGICAL_TESTING_AND_EVALUATION: ITreatmentPreference = {
  title: 'Psychological Testing and Evaluation',
  tag: 'Testing'
};

export const RELATIONAL: ITreatmentPreference = {
  title: 'Relational',
  tag: 'Relational'
};

export const SOMATIC: ITreatmentPreference = {
  title: 'Somatic',
  tag: 'Somatic'
};

export const TRANSPERSONAL: ITreatmentPreference = {
  title: 'Transpersonal',
  tag: 'Transpersonal'
};

export const MOTIVATIONAL_INTERVIEWING: ITreatmentPreference = {
  title: 'Motivational interviewing',
  tag: 'Motivational interviewing'
};

export const PLAY_THERAPY: ITreatmentPreference = {
  title: 'Play therapy',
  tag: 'Play Therapy'
};

export const SOLUTION_FOCUSED_BRIEF_THERAPY: ITreatmentPreference = {
  title: 'Solution-focused Brief Therapy (SFBT)',
  tag: 'SFBT'
};

export const TRAUMA_FOCUSED: ITreatmentPreference = {
  title: 'Trauma-focused',
  tag: 'Trauma Focused'
};

export const TREATMENT_PREFERENCE_LIST: ITreatmentPreference[] = [
  ACCEPTANCE_COMMITMENT_THERAPY,
  ART_THERAPY,
  ATTACHMENT_BASED,
  BEHAVIORAL_MODIFICATION,
  INTEGRATIVE,
  INTERNAL_FAMILY_SYSTEMS,
  INTERPERSONAL_PSYCHOTHERAPY,
  JUNGIAN,
  CHRISTIAN_COUNSELING,
  COGNITIVE_BEHAVIORAL_THERAPY,
  EMOTIONALLY_FOCUSED,
  EMDR,
  BIOFEEDBACK,
  BRAINSPOTTING,
  DIALECTICAL_BEHAVIORAL_THERAPY,
  ECLECTIC,
  EXISTENTIAL,
  GESTALT,
  GOTTMAN_METHOD,
  HUMANISTIC,
  MINDFULNESS,
  NARRATIVE,
  NEUROFEEDBACK,
  PSYCHOANALYTIC,
  PSYCHOBIOLOGICAL_APPROACH_COUPLES_THERAPY,
  PSYCHODYNAMIC,
  PSYCHOLOGICAL_TESTING_AND_EVALUATION,
  RELATIONAL,
  SOMATIC,
  TRANSPERSONAL,
  MOTIVATIONAL_INTERVIEWING,
  PLAY_THERAPY,
  SOLUTION_FOCUSED_BRIEF_THERAPY,
  TRAUMA_FOCUSED
];
